/* Build list for every physical product with options (Oct 2026).
   Each row is one variant picked from per-option dropdowns at any quantity.
   Buy now = add every row and go straight to checkout. Add to cart = add and stay.
   Per-row personalization fields ride along as line item properties. */
(function () {
  'use strict';
  var $  = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var money = function (cents, currency) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; }); return cart; });
  }

  var root = $('[data-build-list]');
  if (!root) return;
  var jsonEl = $('[data-builder-json]', root);
  var data;
  try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }

  var threshold = parseInt(root.dataset.threshold, 10) || 0;
  var currency = data.currency;
  var colors = data.colors || {};
  var rowsEl = $('[data-builder-rows]', root);
  var tpl = $('template[data-builder-row]', root);
  var addBtn = $('[data-builder-add]', root);
  var submit = $('[data-builder-submit]', root);
  var buyNow = $('[data-builder-buynow]', root);
  var goCheckout = false;
  var status = $('[data-builder-status]', root);
  var lookupUrl = root.dataset.lookupUrl;
  var embedded = (data.variants || []).length;
  var totalVariants = parseInt(root.dataset.variantTotal, 10) || embedded;
  var cartTotal = 0;

  var map = {};
  (data.variants || []).forEach(function (v) { map[v.options.join('||')] = v; });
  var pending = {};

  function selects(row) {
    var list = [];
    $$('[data-brow-opt]', row).forEach(function (s) { list[parseInt(s.dataset.browOpt, 10)] = s; });
    return list;
  }
  function key(row) {
    return selects(row).map(function (s) { return s ? s.value : ''; }).join('||');
  }
  function lookup(row) {
    var k = key(row);
    if (map[k] !== undefined || pending[k] || totalVariants <= embedded || !lookupUrl) return;
    var ids = selects(row).map(function (s) { return s.options[s.selectedIndex].dataset.ov; });
    pending[k] = true;
    fetch(lookupUrl + '&option_values=' + ids.join(','), { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-bv]');
        var v = el ? JSON.parse(el.textContent) : null;
        map[k] = (v && v.options && v.options.join('||') === k) ? v : null;
      })
      .catch(function () { map[k] = null; })
      .finally(function () { delete pending[k]; recalc(); });
  }
  function qtyOf(row) {
    var n = parseInt($('[data-brow-input]', row).value, 10);
    return isNaN(n) || n < 0 ? 0 : Math.min(n, 999);
  }
  function paintExtras(row) {
    var sel = selects(row);
    $$('[data-when]', row).forEach(function (box) {
      var s = sel[parseInt(box.dataset.when, 10)];
      var show = !!s && String(box.dataset.whenValue || '').split('|').indexOf(s.value) > -1;
      box.hidden = !show;
      box.style.display = show ? '' : 'none';
    });
  }
  function propsOf(row) {
    var props = {};
    $$('[data-prop]', row).forEach(function (f) {
      var box = f.closest('[data-when]');
      if (box && box.hidden) return;
      var val = String(f.value || '').trim();
      if (val) props[f.dataset.prop] = val;
    });
    return props;
  }
  function missingRequired(row) {
    return $$('[data-prop][data-required]', row).find(function (f) {
      var box = f.closest('[data-when]');
      if (box && box.hidden) return false;
      return !String(f.value || '').trim();
    });
  }
  function paintRow(row) {
    var k = key(row);
    var v = map[k];
    if (v === undefined) lookup(row);
    var loading = v === undefined && (pending[k] || totalVariants > embedded);
    var qty = qtyOf(row);
    $('[data-brow-input]', row).value = qty;
    var ok = !!(v && v.available);
    row.classList.toggle('is-unavailable', !ok && !loading);
    $('[data-brow-error]', row).hidden = ok || loading;
    $('[data-brow-total]', row).textContent = loading ? '...' : money(ok ? v.price * qty : 0, currency);
    $$('[data-brow-colorsel]', row).forEach(function (s) {
      var dot = $('[data-brow-dot]', s.parentNode);
      if (dot) dot.style.background = colors[s.value] || '#3a4044';
    });
    paintExtras(row);
    return ok ? 'ok' : (loading ? 'loading' : 'bad');
  }
  function recalc() {
    var count = 0, total = 0, blocked = false;
    $$('[data-brow]', rowsEl).forEach(function (row) {
      var state = paintRow(row);
      var qty = qtyOf(row);
      if (qty === 0) return;
      if (state !== 'ok') { blocked = true; return; }
      count += qty;
      total += map[key(row)].price * qty;
    });
    $('[data-builder-count]', root).textContent = count + (count === 1 ? ' item' : ' items');
    $('[data-builder-total]', root).textContent = money(total, currency);
    var ship = $('[data-builder-ship]', root);
    if (ship && threshold > 0) {
      var sub = total + cartTotal;
      ship.textContent = sub >= threshold ? 'Free shipping unlocked' : money(threshold - sub, currency) + ' to free shipping';
    }
    submit.disabled = count === 0 || blocked;
    if (buyNow) buyNow.disabled = submit.disabled;
  }
  function addRow(values, qty) {
    var frag = tpl.content.cloneNode(true);
    var row = $('[data-brow]', frag);
    selects(row).forEach(function (s, i) {
      if (s && values && values[i] != null) s.value = values[i];
    });
    $('[data-brow-input]', row).value = qty || 0;
    rowsEl.appendChild(frag);
    recalc();
    return row;
  }

  var tplSel = selects(tpl.content);
  var ci = parseInt(root.dataset.colorIndex, 10);
  var defaults = tplSel.map(function (s) { return s ? s.options[0].value : null; });
  if (ci >= 0 && tplSel[ci]) {
    var want = root.dataset.defaultColor;
    if ($$('option', tplSel[ci]).some(function (o) { return o.value === want; })) defaults[ci] = want;
  }
  var firstPart = tplSel.findIndex(function (s, i) { return s && i !== ci && !s.hasAttribute('data-brow-colorsel'); });
  if (root.dataset.modular === 'true' && firstPart >= 0) {
    $$('option', tplSel[firstPart]).forEach(function (o) {
      var vals = defaults.slice(); vals[firstPart] = o.value; addRow(vals, 0);
    });
  } else {
    addRow(defaults, 1);
  }

  root.addEventListener('change', function (e) { if (e.target.closest('[data-brow]')) recalc(); });
  root.addEventListener('input', function (e) { if (e.target.matches('[data-brow-input]')) recalc(); });
  root.addEventListener('click', function (e) {
    var step = e.target.closest('[data-brow-qty]');
    if (step) {
      var row = step.closest('[data-brow]');
      $('[data-brow-input]', row).value = Math.max(0, qtyOf(row) + parseInt(step.dataset.browQty, 10));
      recalc();
      return;
    }
    var rm = e.target.closest('[data-brow-remove]');
    if (rm) {
      rm.closest('[data-brow]').remove();
      if (!$('[data-brow]', rowsEl)) addRow(defaults, 0);
      recalc();
    }
  });
  addBtn.addEventListener('click', function () {
    var rows = $$('[data-brow]', rowsEl);
    var last = rows[rows.length - 1];
    var vals = last ? selects(last).map(function (s) { return s ? s.value : null; }) : defaults;
    var row = addRow(vals, 0);
    var first = $('select', row);
    if (first) first.focus();
  });

  function resetBuyNow() {
    goCheckout = false;
    if (buyNow) { buyNow.textContent = 'Buy now'; buyNow.disabled = submit.disabled; }
  }

  submit.addEventListener('click', function () {
    var missing = null;
    $$('[data-brow]', rowsEl).forEach(function (row) {
      if (missing || !qtyOf(row)) return;
      missing = missingRequired(row);
    });
    if (missing) {
      status.textContent = 'Fill in the highlighted detail before adding.';
      resetBuyNow();
      missing.focus();
      return;
    }

    var merged = {};
    $$('[data-brow]', rowsEl).forEach(function (row) {
      var qty = qtyOf(row);
      var v = map[key(row)];
      if (!qty || !v || !v.available) return;
      var props = propsOf(row);
      var k = v.id + '||' + JSON.stringify(props);
      if (!merged[k]) merged[k] = { id: Number(v.id), quantity: 0, properties: props };
      merged[k].quantity += qty;
    });
    var items = Object.keys(merged).map(function (k) {
      var m = merged[k];
      var item = { id: m.id, quantity: m.quantity };
      if (Object.keys(m.properties).length) item.properties = m.properties;
      return item;
    });
    if (!items.length) { resetBuyNow(); return; }

    var label = submit.textContent;
    submit.disabled = true; submit.textContent = 'Adding';
    status.textContent = '';

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'add failed'); return j; }); })
      .then(function () { return refreshCartCount(); })
      .then(function (cart) {
        if (goCheckout) { window.location.href = '/checkout'; return; }
        if (cart) cartTotal = cart.total_price;
        var n = items.reduce(function (s, i) { return s + i.quantity; }, 0);
        status.innerHTML = n + (n === 1 ? ' item' : ' items') + ' added. <a href="/checkout">Check out now</a> or <a href="' + root.dataset.cartUrl + '">view cart</a>.';
        $$('[data-brow-input]', rowsEl).forEach(function (i) { i.value = 0; });
        $$('[data-prop]', rowsEl).forEach(function (f) { if (f.tagName !== 'SELECT') f.value = ''; });
        recalc();
      })
      .catch(function (err) {
        status.textContent = 'Could not add that: ' + err.message + '. Nothing was charged; try again.';
        submit.disabled = false;
        resetBuyNow();
      })
      .finally(function () { submit.textContent = label; });
  });

  if (buyNow) buyNow.addEventListener('click', function () {
    goCheckout = true;
    buyNow.disabled = true;
    buyNow.textContent = 'Going to checkout';
    submit.disabled = false;
    submit.click();
  });

  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) { cartTotal = cart.total_price || 0; recalc(); })
    .catch(function () { /* keep the build-only figure */ });
})();
